import React, { useState } from "react";
import CustomDialog from "../../../components/layouts/common/CustomDialog";
import { closeModal } from "../../../store/actions/modalAction";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../../store/actions/commonAction";
import OrderCancelUI from "./OrderCancelUI";
import { updateOrderApi } from "../../../apis/patient.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import {
  ORDER_PROCESS_STATUS,
  SNACK_BAR_VARIETNS,
} from "../../../utils/constants";

const OrderCancelController = ({ params, status, callBack }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [fields, setFields] = useState({
    reason: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (fields?.reason === "") {
      setFields({ ...fields, err: "Reason is required" });
      setLoading(false);
      return;
    }
    dispatch(
      callApiAction(
        async () =>
          await updateOrderApi({
            id: params?.order_ID,
            status: ORDER_PROCESS_STATUS.ORDER_REJECTED,
            reason: fields?.reason,
          }),
        async (response) => {
          dispatch(
            callSnackBar(
              "Order Cancelled Successfully",
              SNACK_BAR_VARIETNS.success
            )
          );
          await callBack();
          dispatch(closeModal("orderCancel"));
          setLoading(false);
        },
        async (err) => {
          dispatch(callSnackBar("Error", SNACK_BAR_VARIETNS.error));
          dispatch(closeModal("orderCancel"));
          setLoading(false);
        }
      )
    );
  };

  return (
    <CustomDialog
      id={"orderCancel"}
      loading={loading}
      onSubmit={onSubmit}
      title={"Order Cancellation"}
      closeText="Close"
      confirmText={"Submit"}
    >
      <OrderCancelUI
        params={params}
        fields={fields}
        setFields={setFields}
        loading={loading}
        setLoading={setLoading}
      />
    </CustomDialog>
  );
};

export default OrderCancelController;
